var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6574 4.28711C10.9023 4.28709 11.1404 4.36776 11.3349 4.51665L11.4463 4.6136L14.4616 7.62997H21.8003C22.6529 7.62992 23.4734 7.9557 24.0938 8.54065C24.7141 9.12561 25.0875 9.92551 25.1376 10.7767L25.1431 10.9728V19.8871C25.1432 20.7398 24.8174 21.5602 24.2324 22.1806C23.6475 22.801 22.8476 23.1744 21.9964 23.2244L21.8003 23.23H6.20028C5.34762 23.23 4.52716 22.9042 3.90679 22.3193C3.28641 21.7343 2.91302 20.9344 2.86299 20.0832L2.85742 19.8871V7.62997C2.85737 6.7773 3.18316 5.95685 3.76811 5.33648C4.35306 4.7161 5.15297 4.3427 6.00416 4.29268L6.20028 4.28711H10.6574Z",
    fill: "#FFB949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folderIcon.46d3f6f60ce726b57e28a942fedc480b.svg";
export { ForwardRef as ReactComponent };